import {Controller} from "@hotwired/stimulus";
import $ from 'jquery';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static outlets = [
        'payment--direct-payment-link',
    ];

    static targets = [
        'didMeetingHappenStep',
        'areKycDocumentsRequiredStep',
        'cashingOutMeetingHappenedStep',
        'cashingOutMeetingDidNotHappenStep',
        'cashingSuccessStep',
        'cashingFailedStep',
        'newPaymentBtn',
    ];

    static values = {
        bookingId: Number,
        paymentId: Number,
        hasMeetingHappened: Boolean,
        areKycDocumentsRequired: Boolean,
        urlParameter: Boolean,
        litigantId: Number,
        litigantName: String,
    };

    connect() {
        $(this.element).on('hide.bs.modal', () => {
            this.didMeetingHappenStepTarget.style.setProperty('display', 'none');
            this.areKycDocumentsRequiredStepTarget.style.setProperty('display', 'none');
            this.cashingOutMeetingHappenedStepTarget.style.setProperty('display', 'none');
            this.cashingOutMeetingDidNotHappenStepTarget.style.setProperty('display', 'none');
            this.cashingSuccessStepTarget.style.setProperty('display', 'none');
            this.cashingFailedStepTarget.style.setProperty('display', 'none');

            $(this.areKycDocumentsRequiredStepTarget).find('.direct-payment-text').addClass('d-none')
            $(this.areKycDocumentsRequiredStepTarget).find('.payment-text').removeClass('d-none')

            this.hasMeetingHappenedValue = undefined;
            this.directPaymentValue = undefined;
        });

        if (this.hasUrlParameterValue) {
            this.hasMeetingHappenedValue = this.urlParameterValue;
            this.open();
        }
    }

    disconnect() {
        $(this.element).off('hide.bs.modal');
    }

    async open() {
        if (false === this.hasHasMeetingHappenedValue) {
            showPreloader()

            const url = routes['app_booking_hasmeetinghappened'].replace('__id__', this.bookingIdValue);
            const result = await fetch(url, {method: 'GET'}).then((response) => response.json());

            hidePreloader();

            if (null !== result.hasMeetingHappened) {
                this.hasMeetingHappenedValue = result.hasMeetingHappened;
            }
        }

        if (false === this.hasHasMeetingHappenedValue) {
            this.didMeetingHappenStepTarget.style.removeProperty('display');
            // } else if (this.areKycDocumentsRequiredValue) {
            //     this.areKycDocumentsRequiredStepTarget.style.removeProperty('display');
        } else if (this.hasMeetingHappenedValue) {
            this.cashingOutMeetingHappenedStepTarget.style.removeProperty('display');
        } else if (!this.hasMeetingHappenedValue) {
            this.cashingOutMeetingDidNotHappenStepTarget.style.removeProperty('display');
        }

        hidePreloader();

        $(this.element).modal({
            backdrop: 'static',
            focus: false,
            show: true,
        });

        this.paymentDirectPaymentLinkOutlet.litigantIdValue = this.litigantIdValue;
        this.paymentDirectPaymentLinkOutlet.litigantNameValue = this.litigantNameValue;
    }

    meetingHappened() {
        this.hasMeetingHappenedValue = true;
        this.didMeetingHappenStepTarget.style.setProperty('display', 'none');

        this.cashingOutMeetingHappenedStepTarget.style.removeProperty('display');

        $.ajax({
            url: routes['app_booking_changemeetinghappened'].replace('__id__', this.bookingIdValue),
            data: {meetingHappened: true}
        });
    }

    meetingDidNotHappen() {
        this.hasMeetingHappenedValue = false;
        this.didMeetingHappenStepTarget.style.setProperty('display', 'none');

        this.cashingOutMeetingDidNotHappenStepTarget.style.removeProperty('display');

        $.ajax({
            url: routes['app_booking_changemeetinghappened'].replace('__id__', this.bookingIdValue),
            data: {meetingHappened: false}
        });
    }

    cashOut(event) {
        if (this.areKycDocumentsRequiredValue) {
            this.areKycDocumentsRequiredStepTarget.style.removeProperty('display');
            this.cashingOutMeetingHappenedStepTarget.style.setProperty('display', 'none');
            this.cashingOutMeetingDidNotHappenStepTarget.style.setProperty('display', 'none');
            return;
        }

        event.preventDefault();

        showPreloader();

        const url = routes['app_payments_capture'].replace('__id__', this.paymentIdValue);
        const data = {meetingHappened: this.hasMeetingHappenedValue};

        $.get(url, data, result => {
            const $form = $(result);

            $('body').append($form);

            $.ajax({
                type: $form.attr('method'),
                data: $form.serializeArray(),
                dataType: 'json',
                url: $form.attr('action'),
                success: result => {
                    this.cashingOutMeetingHappenedStepTarget.style.setProperty('display', 'none');
                    this.cashingOutMeetingDidNotHappenStepTarget.style.setProperty('display', 'none');

                    hidePreloader();

                    if (result.captured) {
                        this.cashingSuccessStepTarget.style.removeProperty('display');
                    } else {
                        this.cashingFailedStepTarget.style.removeProperty('display');
                    }

                    $(this.element).on('hide.bs.modal', () => {
                        showPreloader();

                        window.location.reload();
                    });
                },
            });
        });
    }

    cancelCapture(event) {
        event.preventDefault();

        showPreloader();

        const url = routes['app_payments_preauthorizationcancel'].replace('__id__', this.paymentIdValue);
        const data = {meetingHappened: this.hasMeetingHappenedValue};

        $.get(url, data, result => {
            const $form = $(result);

            $('body').append($form);

            $.ajax({
                type: $form.attr('method'),
                data: $form.serializeArray(),
                dataType: 'json',
                url: $form.attr('action'),
                success: result => {
                    this.cashingOutMeetingDidNotHappenStepTarget.style.setProperty('display', 'none');

                    hidePreloader();

                    if (result.cancelled) {
                        this.cashingFailedStepTarget.style.removeProperty('display');
                    } else {
                        $(this.element).modal('hide');
                    }

                    $(this.element).on('hide.bs.modal', () => {
                        showPreloader();

                        window.location.reload();
                    });
                }
            });
        });
    }
}
